import React from 'react';
import './Loader.css';

const messages = [
    "Consultation des archives cosmiques en cours.",
    "Nous interrogeons les étoiles à votre sujet.",
];

const Loader = () => {
    const randomMessage = messages[Math.floor(Math.random() * messages.length)];

    return (
        <div className="loader-container">
            <div className="newtons-cradle">
                <div className="newtons-cradle__dot"></div>
                <div className="newtons-cradle__dot"></div>
                <div className="newtons-cradle__dot"></div>
                <div className="newtons-cradle__dot"></div>
            </div>
            <p className="loader-message">Juste un peu de patience...<br></br>{randomMessage}</p>
        </div>
    );
};

export default Loader; 